import React, { useState, useRef } from 'react';

import './Calendar.scss';
import { link } from '../../helpers/link';
import sendEvent from '../../helpers/tracking';
import { getString } from '../../helpers/styles';
import { validateDate } from '../../helpers/form';
import Transition from '../Transition/Transition.jsx';
import CalendarPopup from '../CalendarPopup/CalendarPopup.jsx';
import { pregnancyWeekList, babyWeekList } from '../../helpers/userWeek';

import LeftArrow from '../../shared/assets/icons/leftArrow.svg';
import CalendarIcon from '../../shared/assets/icons/calendar.svg';
import RightArrow from '../../shared/assets/icons/rightArrow.svg';

export default function Calendar(props) {
  const now = new Date();

  const [foldedOut, togglePopup] = useState(false);
  const [selectedDate, changeSelectedDate] = useState({});

  return (
    <section id="calendar">
      <div id="calendar_pregnancy">
        <p className="calendar_title">Zwangerschapskalender</p>

        <Slider
          weeks={pregnancyWeekList}
          isHomePage={props.isHomePage}
          eventTrackingCodes={['home', 'zwangerschapskalender']}
        />
      </div>

      <div id="calendar_baby">
        <p className="calendar_title">Babykalender</p>

        <Slider
          weeks={babyWeekList}
          isHomePage={props.isHomePage}
          eventTrackingCodes={['home', 'babykalender']}
        />
      </div>

      <div
        id="calendar_calculation_date"
        className={getString('calendar_scaled', foldedOut)}
      >
        <p className="calendar_title">Bereken je week</p>

        <form onSubmit={(e) => calculateDate(e)}>
          <input
            autoComplete="off"
            data-validated-value=""
            id="calendar_selected_date"
            onChange={(e) => validateDate(e.target)}
            onClick={(e) => (e.target.placeholder = 'DD-MM-JJJJ')}
            placeholder="Eerste dag van je laatste menstruatie"
            pattern="(0[1-9]|1[0-9]|2[0-9]|3[01])-(0[1-9]|1[012])-[0-9]{4}"
          />

          <span
            onClick={() => togglePopup(!foldedOut)}
            className={getString('calendar_popup_visible', foldedOut)}
          >
            <CalendarIcon />
          </span>

          <button>Berekenen</button>
        </form>

        <Transition on={foldedOut}>
          <CalendarPopup
            withTriangle={true}
            togglePopup={togglePopup}
            field="calendar_selected_date"
            changeSelectedDate={changeSelectedDate}
            year={selectedDate.year || now.getFullYear()}
            month={selectedDate.month || now.getMonth() + 1}
          />
        </Transition>
      </div>
    </section>
  );

  function calculateDate(e) {
    e.preventDefault();

    const input = document.getElementById('calendar_selected_date');

    if (!input.value) return input.classList.add('calendar_date_required');

    location.href = `/uitgerekende-datum?date=${input.value}`;
  }
}

function Slider(props) {
  const list = useRef(null);
  const [currentPage, togglePage] = useState(1);

  const lastPage = Math.ceil(props.weeks.length / 4);

  return (
    <section className="calendar_slider">
      <div>
        <div>
          {currentPage !== 1 && (
            <div
              className="calendar_arrow_left calendar_arrow"
              onClick={() => move('backward')}
            >
              <LeftArrow />
            </div>
          )}

          <ul ref={list}>
            {props.weeks.map((week, idx) => (
              <li
                key={idx + 1}
                onClick={() =>
                  props.isHomePage && sendEvent(...props.eventTrackingCodes)
                }
              >
                {link(
                  <span className="calendar_slider_week_label">
                    {week.number}
                    <span>{week.label}</span>
                  </span>,
                  week.link
                )}
              </li>
            ))}
          </ul>

          {currentPage !== lastPage && (
            <div
              className="calendar_arrow_right calendar_arrow"
              onClick={() => move('forward')}
            >
              <RightArrow />
            </div>
          )}
        </div>
      </div>
    </section>
  );

  function move(direction) {
    const isForward = direction === 'forward';

    const translateX = `${isForward ? `-${currentPage}` : `-${currentPage - 2}`}00%`;

    list.current.style.cssText = `
      transition-duration: .3s;
      transform: translateX(${translateX});
      transition-property: transform;
    `;

    togglePage((previousPage) =>
      isForward ? previousPage + 1 : previousPage - 1
    );
  }
}
